import moment from 'moment';

(() => {
  class AppointmentBookingController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, $state, ngDialog, Orders) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        $state,
        ngDialog,
        Orders,
        order: $scope.ngDialogData.order,
        bookingdata: $scope.ngDialogData.bookingdata,
        patient_address_timezone: $scope.ngDialogData.patient_address_timezone
      });

      if (this.bookingdata) {
        this.page = 'reschedule';
        this.date_scheduled = this.getDateParts(this.bookingdata.start_time);
        this.date_scheduled_formatted = this.formatDateScheduled(); // this.date_scheduled.weekday => Monday
        // this.formatDateScheduled() => January 27 at 8:45 AM
        // this.patient_address_timezone.zoneAbbr => PST
      } else {
        this.getAvailableDates(false, false);
      }
    }

    removeZero(day) {
      let new_day = parseInt(day) + "";
      return new_day;
    }

    formatDateSelected() {
      // January 27 at 8:45 AM
      return this.date_selected.month_name + " " + this.date_selected.day + " at " + this.date_selected.hour + ":" + this.date_selected.minute + " " + this.date_selected.type;
    }

    formatDateScheduled() {
      // January 27 at 8:45 AM
      return this.date_scheduled.month_name + " " + this.date_scheduled.day + " at " + this.date_scheduled.hour + ":" + this.date_scheduled.minute + " " + this.date_scheduled.type;
    }

    formatDateRetrieved() {
      // January, 27 2020
      return this.date_option_retrieved.month + ", " + this.removeZero(this.date_option_retrieved.day) + " " + this.date_option_retrieved.year;
    }

    formatTimeSlot(start_time) {
      let time_array_1 = start_time.split(" ");
      let time_array_2 = time_array_1[1].split(":");
      let hour = parseInt(time_array_2[0]);
      let minute = time_array_2[1];
      let type;

      if (hour == 12) {
        type = "PM";
      } else if (hour > 12) {
        type = "PM";
        hour = hour - 12;
      } else {
        type = "AM";
      }

      return hour + ":" + minute + " " + type;
    }

    getDateParts(datetime) {
      //"datetime": "2019-12-31 11:00:00",
      const weekday_array = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const month_array = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      let datetime_array = datetime.split(" ");
      let date = datetime_array[0];
      let date_array = datetime_array[0].split("-");
      let time_array = datetime_array[1].split(":");
      let year = date_array[0];
      let month = date_array[1];
      let day = parseInt(date_array[2]);
      let hour = parseInt(time_array[0]);
      let minute = time_array[1];
      let type;

      if (hour == 12) {
        type = "PM";
      } else if (hour > 12) {
        type = "PM";
        hour = hour - 12;
      } else {
        type = "AM";
      }

      let weekday = weekday_array[new Date(year, month - 1, day).getDay()];
      let month_name = month_array[month - 1];
      let datetime_object = {
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        type: type,
        weekday: weekday,
        month_name: month_name,
        date: date
      };
      return datetime_object;
    }

    reschedule() {
      this.getAvailableDates(true, false);
    }

    goToPreviousAvailable() {
      if (this.date_option_selected.previous) this.selectDate(true, this.date_option_selected.previous);
    }

    goToNextAvailable() {
      if (this.date_option_selected.next) this.selectDate(true, this.date_option_selected.next);
    }

    getAvailableDates(reschedule = false, show_booking_fail_error = false) {
      var this2 = this;
      let today = moment().format('YYYY-MM-DD');
      let paid = moment(this.order.paid).format('YYYY-MM-DD'); // console.log("today: ", today);
      // console.log("paid: ", paid);

      let days_passed = moment(today).diff(moment(paid), 'days'); // console.log("days_passed: ", days_passed);

      this.Orders.getCallBookingDates(this2.order.schedule_code, this2.patient_address_timezone.timezoneUrlEncoded, this2.order.id, null, null).then(result2 => {
        // console.log("Orders.getCallBookingDates: ", result2);
        if (!result2.data.available) {
          if (show_booking_fail_error) {
            this2.page = 'last-appointment-taken';
          } else {
            this2.page = 'no-appointments-available';
          }
        } else {
          this2.dates = result2.data.dates; // Here we set the PREVIOUS and NEXT available Date for each Date

          let previous = "";
          let next = "";
          this2.dates.forEach(option => {
            if (option.available) {
              option.previous = previous;
              previous = option.date;
            }
          });
          this2.dates.reverse();
          this2.dates.forEach(option => {
            if (option.available) {
              option.next = next;
              next = option.date;
            }
          });
          this2.dates.reverse();
          console.log("Dates array: ", this2.dates);
          let date_scheduled_still_available = false;

          if (reschedule) {
            this2.dates.forEach(option => {
              if (option.available && option.date == this2.date_scheduled.date) date_scheduled_still_available = true;
            });
          }

          if (reschedule && date_scheduled_still_available) {
            this2.selectDate(true, this2.date_scheduled.date, show_booking_fail_error);
          } else {
            let first_date_available = null;
            this2.dates.forEach(option => {
              if (option.available && !first_date_available) first_date_available = option.date;
            });
            this2.selectDate(true, first_date_available, show_booking_fail_error);
          }
        }
      }).catch(err => {
        if (show_booking_fail_error) {
          this2.page = 'last-appointment-taken';
        } else {
          this2.page = 'no-appointments-available';
        }
      });
    }

    selectDate(available, date_selected, show_booking_fail_error = false) {
      var this2 = this;

      if (available) {
        this.dates.forEach(option => {
          if (option.date == date_selected) {
            option.selected = true;
            this.date_option_selected = option;
          } else {
            option.selected = false;
          }
        });
        this.times = [];

        if (show_booking_fail_error) {
          this.page = 'appointment-taken';
        } else {
          this.page = 'select-date-time';
        }

        this.Orders.getCallBookingTimes(this2.order.schedule_code, date_selected, this2.patient_address_timezone.timezoneUrlEncoded).then(result => {
          console.log("Orders.getCallBookingTimes: ", result);

          if (result.data && result.data.slots) {
            this2.date_option_retrieved = result.data;
            this2.date_option_retrieved_formatted = this2.formatDateRetrieved();
            let slots = result.data.slots;

            for (var key in slots) {
              if (slots.hasOwnProperty(key)) {
                if (slots[key].available) {
                  let start_time_display = this2.formatTimeSlot(slots[key].start_time);
                  this2.times.push({
                    start_time: slots[key].start_time,
                    start_time_display: start_time_display,
                    selected: false,
                    available: slots[key].available
                  });
                }
              }
            }
          }
        }).catch(err => {
          console.log(err);
        });
      }
    }

    selectTime(available, start_time_selected) {
      if (available) {
        this.times.forEach(option => {
          if (option.start_time == start_time_selected) {
            option.selected = true;
            this.time_option_selected = option;
          } else {
            option.selected = false;
          }
        });
        this.date_selected = this.getDateParts(this.time_option_selected.start_time);
        this.date_selected_formatted = this.formatDateSelected();
        this.page = 'confirm-booking';
      }
    }

    confirmBooking() {
      var this2 = this;
      let bookingText;
      this2.order.schedule_code === 'slv' ? bookingText = 'Video' : bookingText = 'Phone call';
      this.Orders.createCallBooking(this.order.id, this.time_option_selected.start_time, this.patient_address_timezone.timezone, this.order.schedule_code).then(result => {
        this2.toastr.success(`${bookingText} booking saved successfully.`);
        this2.page = 'booking-done';
        this2.$rootScope.$broadcast('booking:refresh');
      }).catch(err => {
        console.log("Error:", err);
        this.getAvailableDates(false, true);
      });
    }

    goBack() {
      this.page = 'select-date-time';
    }

    cancel() {
      var this2 = this;
      let bookingText;
      this2.order.schedule_code === 'slv' ? bookingText = 'Video' : bookingText = 'Phone call';
      this2.Orders.deleteCallBooking(this2.bookingdata.id, this2.order.schedule_code).then(result => {
        this2.$rootScope.$broadcast('booking:refresh');
        this2.toastr.success(`${bookingText} booking cancelled successfully.`);
        this2.$scope.closeThisDialog(null);
      }).catch(err => {
        console.log("Error:", err);
        this2.toastr.error(`Error cancelling ${bookingText} booking.`);
      });
    }

    close() {
      this.$rootScope.$broadcast('booking:refresh');
      this.$scope.closeThisDialog(null);
    }

  }

  AppointmentBookingController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "$state", "ngDialog", "Orders"];
  angular.module('pims').controller('AppointmentBookingController', AppointmentBookingController);
})();